class BaseModel {

    id = '';
    uuid = '';
    errorMsg = '';

    constructor() {

    }

    fromJSON(data) {
        this.errorMsg = '';
        this.uuid = data.uuid;
        this.id = data['id'];
    }

    toJSON() {

    }

    setError(msg = '') {
        this.errorMsg = msg;
    }
}



export default BaseModel;